import { useEffect, useState } from 'react';
import * as api from '../api';

// A given user's profile photo (from their HR employee record) as an object URL, for the admin
// user pages. Same approach as useMyPhoto: null when there is no photo (callers show initials).
export default function useUserPhoto(userId) {
  const [url, setUrl] = useState(null);

  useEffect(() => {
    if (!userId) { setUrl(null); return undefined; }
    let alive = true;
    let objectUrl = null;
    api.getUserPhoto(userId)
      .then(b => {
        if (!alive || !b || !b.size) return;
        objectUrl = URL.createObjectURL(b);
        setUrl(objectUrl);
      })
      .catch(() => { if (alive) setUrl(null); });
    return () => { alive = false; if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [userId]);

  return url;
}
